import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { SITE } from "@/data/site";
import { PRODUCTS } from "@/data/products";

export const Footer = () => (
  <footer className="bg-[#0F1A28] text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <div className="flex items-center gap-3 mb-5">
          <img src={SITE.logo} alt="Empire Aluminium Windows logo" className="h-10 w-auto" />
          <span className="font-heading font-extrabold text-white leading-none">
            <span className="block text-base uppercase">Empire</span>
            <span className="block text-[10px] uppercase tracking-[0.18em] text-[#29CC9A]">Aluminium Windows</span>
          </span>
        </div>
        <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
          Factory-direct aluminium windows, doors, bifolds, partitions and shopfronts. Fabricated in Romford, supplied and installed across London and the surrounding areas.
        </p>
      </div>

      <div className="md:col-span-3">
        <h3 className="font-heading text-white font-bold text-sm uppercase tracking-[0.15em] mb-5">Products</h3>
        <ul className="space-y-2.5">
          {PRODUCTS.slice(0, 7).map((p) => (
            <li key={p.slug}>
              <Link to={`/products/${p.slug}`} className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">
                {p.name}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/products" className="text-sm font-bold text-[#29CC9A]">All products →</Link>
          </li>
        </ul>
      </div>

      <div className="md:col-span-2">
        <h3 className="font-heading text-white font-bold text-sm uppercase tracking-[0.15em] mb-5">Company</h3>
        <ul className="space-y-2.5">
          <li><Link to="/trade-supply" className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">Trade Supply</Link></li>
          <li><Link to="/supply-installation" className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">Supply & Install</Link></li>
          <li><Link to="/colour-visualiser" className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">Colour Visualiser</Link></li>
          <li><Link to="/about" className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">Our Factory</Link></li>
          <li><Link to="/contact" className="text-sm text-slate-400 hover:text-[#29CC9A] transition-colors duration-200">Get a Quote</Link></li>
        </ul>
      </div>

      <div className="md:col-span-3">
        <h3 className="font-heading text-white font-bold text-sm uppercase tracking-[0.15em] mb-5">Visit the Factory</h3>
        <address className="not-italic space-y-3 text-sm text-slate-400">
          <p className="flex gap-2.5"><MapPin size={16} className="text-[#29CC9A] shrink-0 mt-0.5" />
            {SITE.address.line1}, {SITE.address.line2}, {SITE.address.town}, {SITE.address.postcode}
          </p>
          <p className="flex gap-2.5 items-center"><Phone size={15} className="text-[#29CC9A] shrink-0" />
            <a href={SITE.phoneHref} className="hover:text-white transition-colors duration-200" data-testid="footer-phone-link">{SITE.phone}</a>
          </p>
          <p className="flex gap-2.5 items-center"><Mail size={15} className="text-[#29CC9A] shrink-0" />
            <a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors duration-200" data-testid="footer-email-link">{SITE.email}</a>
          </p>
          <p className="flex gap-2.5"><Clock size={15} className="text-[#29CC9A] shrink-0 mt-0.5" />{SITE.hours}</p>
        </address>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-slate-500">
        <p data-testid="footer-legal-note">© {new Date().getFullYear()} Empire Aluminium Windows is a trading name of Empire Facade Group Ltd (company no. 13655313). All rights reserved.</p>
        <p>Part of the Empire Facade Group · Aluminium fabricators · Romford · London and the surrounding areas</p>
      </div>
    </div>
  </footer>
);
